import React, { useState } from "react";
import PowerCard from "./PowerCard";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const Quade = ({
    powerData, linkData, isEditable, pointsRemaining, powers, setPowers,
    solidLinks, setSolidLinks,
    dashedLinks, setDashedLinks,
    selectedPowerID, setSelectedPowerID
}) => {

    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0.0);
    const [startY, setStartY] = useState(0.0);
    const [pointX, setPointX] = useState(0.0);
    const [pointY, setPointY] = useState(0.0);
    const [quadeScale, setQuadeScale] = useState(0.125);
    const [originX, setOriginX] = useState(0.0);
    const [originY, setOriginY] = useState(0.0);
    

    const minZoom = 0.12;
    const maxZoom = 1.0;

    // data

    function mouseIsDown(e) {
        setIsDown(true);
        setStartX(e.clientX - pointX);
        setStartY(e.clientY - pointY);
    }

    function mouseUp(e) {
        setIsDown(false);
    }

    function setCanScroll(canScroll) {
        if (canScroll) {
            document.body.style.height = "auto";
            document.body.style.overflow = "auto";
        } else {
            document.body.style.height = "100%";
            document.body.style.overflow = "hidden";
        }
    }

    function mouseEnter(e) {
        setCanScroll(false);
    }

    function mouseLeave(e) {
        setCanScroll(true);
        setIsDown(false);
    }

    function updateScrollPoint(x, y) {
        // did a lot of trial and error, could be wrong
        // 950 and 508 come from the dimensions of Powers--container-inner.
        // Could probably grab them some other way
        // no idea where the other numbers come from-- probably related to grid

        const gridWidth = (536 + 2) * 7 + 950;
        const gridHeight = (536 + 2) * 7 + 508;
        const xMin = (-1 * gridWidth * quadeScale) - 950 - 5000;
        const yMin = (-1 * gridHeight * quadeScale) - 508 - 5000;

        const px = Math.max(xMin, (Math.min(50, x)));
        const py = Math.max(yMin, (Math.min(50, y)));
        setPointX(px);
        setPointY(py);
        
    }

    function mouseScroll(e) {
        var scrollContainer = document.getElementById("quade-container");
        //var scrollContents = document.getElementById("quade-contents");
        var rect = scrollContainer.getBoundingClientRect();
        const mx = e.clientX - rect.left;
        const my = e.clientY - rect.top;
        var xs = (mx - pointX) / quadeScale,
            ys = (my - pointY) / quadeScale;
        var delta = (e.wheelDelta ? e.wheelDelta : -e.deltaY);
        const updatedScale = Math.min(maxZoom, Math.max(minZoom, delta > 0 ? quadeScale * 1.1 : quadeScale / 1.1));
        setQuadeScale(updatedScale);
        //var rect = scrollContents.getBoundingClientRect();
        const px = mx - (xs * updatedScale);
        const py = my - (ys * updatedScale);
        //setOriginX(e.clientX - rect.x);
        //setOriginY(e.clientY - rect.y);
        updateScrollPoint(px, py);
    }

    function mouseTryScroll(e) {
        e.preventDefault();
    }

    function mouseMove(e) {
        e.preventDefault();
        if (isDown) {
            const px = e.clientX - startX;
            const py = e.clientY - startY;
            updateScrollPoint(px, py);
        }
    }

    // drawing helper functions

    function CalculateCardLineCoords(gridPos1, gridPos2, cellW, cellH) {

        let extend = 2; //temp
        let longExtend = 10; //temp
        let vertLongExtend = 60;

        // cell 1 corners
        const cell1X1 = (gridPos1[0] - 1) * cellW;
        const cell1Y1 = (gridPos1[1] - 1) * cellH;
        const cell1X2 = (gridPos1[0]) * cellW;
        const cell1Y2 = (gridPos1[1]) * cellH;
        // cell 2 corners
        const cell2X1 = (gridPos2[0] - 1) * cellW;
        const cell2Y1 = (gridPos2[1] - 1) * cellH;
        const cell2X2 = (gridPos2[0]) * cellW;
        const cell2Y2 = (gridPos2[1]) * cellH;
        
        let lineX1 = 0;
        let lineY1 = 0;
        let lineX2 = 0;
        let lineY2 = 0;

        let horizontal = true;
        let vertical = true;

        // get the x coords
        if (gridPos1[0] > gridPos2[0]) {
            // first card is to the right of second card
            // start from the right side of second card
            lineX1 = cell1X1;
            lineX2 = cell2X2;
        } else if (gridPos1[0] < gridPos2[0]) {
            // first card is to the left of second card
            lineX1 = cell1X2;
            lineX2 = cell2X1;
        } else {
            // cards are lined up horizonally
            // halfway between the two coords
            lineX1 = (cell1X1 + cell1X2)/2;
            lineX2 = lineX1;
            horizontal = false;
        }
        // get the y coords
        if (gridPos1[1] > gridPos2[1]) {
            // first card is above second card
            // start from the top side of second card
            lineY1 = cell1Y1;
            lineY2 = cell2Y2;
        } else if (gridPos1[1] < gridPos2[1]) {
            // first card is below second card
            lineY1 = cell1Y2;
            lineY2 = cell2Y1;
        } else {
            // cards are lined up vertically
            // halfway between the two coords
            lineY1 = (cell1Y1 + cell1Y2) / 2;
            lineY2 = lineY1;
            vertical = false;
        }
        if (horizontal && vertical) {
            // vertical centering
            if (gridPos1[1] > gridPos2[1]) {
                lineY1 += cellH / 2;
                lineY2 -= cellH / 2;
            } else {
                lineY1 -= cellH / 2;
                lineY2 += cellH / 2;
            }
            // TODO: is horizontal centering ever necessary?
            if (lineY1 > lineY2) {
                lineY1 += longExtend;
            } else {
                lineY2 += longExtend;
            }
            if (lineX1 > lineX2) {
                lineX1 += longExtend;
            } else {
                lineX2 += longExtend;
            }
        } else if (horizontal) {
            lineX1 -= longExtend / 2;
            lineX2 += longExtend / 2;
            lineX2 += extend;
        } else if (vertical) {
            lineY1 -= vertLongExtend / 2;
            lineY2 += vertLongExtend / 2;
            lineY2 += extend;
        }
        return [
            [lineX1, lineY1],
            [lineX2, lineY2]
        ];        
    }

    // power data management

    function HasAnyPowers() {
        if (Object.keys(powers).length === 0) {
            return false;
        }
        for (let p in powers) {
            if (powers[p] !== 0) {
                return true;
            }
        }
        return false;
    }

    function PowerCost(powerItem, isSkip=false) {
        if (powerItem.isInvestigative) {
            return 1;
        } else if (powerItem.isGRF) {
            let isGritty = false; //temp. need to get this from appropriate place
            return isGritty ? 0 : 2;
        }
        return isSkip ? 2 : 4;
    }

    function CalculateLinkCost(powerLink) {
        return powerLink.isDotted ? 4 : 0;
    }

    function GetLinkBetweenPowers(powerID1, powerID2) {
        for (let linkID in linkData) {
            let link = linkData[linkID];
            if (link.powerIDs.includes(powerID1) &&
                link.powerIDs.includes(powerID2)) {
                return link;
            }
        }
        return null;
    }

    function FindCheapestLinkToPower(powerItem) {
        let cheapestCost = -1;
        let cheapestLink = null;
        for (let powerID in powers) {
            if (powers[powerID] === 0) {
                continue;
            }
            let link = GetLinkBetweenPowers(parseInt(powerID), powerItem.id);
            if (link !== null) {
                const cost = CalculateLinkCost(link);
                if (cheapestCost < 0 || cost < cheapestCost) {
                    cheapestCost = cost;
                    cheapestLink = link;
                }
            }
        }
        return cheapestLink;
    }

    function CalculateLinkedPowerCost(powerItem, isSkip=false) {
        if (!HasAnyPowers()) {
            return PowerCost(powerItem);
        }
        let cheapestLink = FindCheapestLinkToPower(powerItem);
        if (cheapestLink === null) {
            return -1;
        }
        // dashed lines cost 4 on their own
        let costToReach = CalculateLinkCost(cheapestLink);
        return costToReach + PowerCost(powerItem, isSkip);
    }

    function IsPowerLearned(powerItem) {
        let powerPoints = powers[powerItem.id];
        if (powerPoints === undefined) {
            return false;
        }
        return powerPoints > 0;
    }

    function IsPowerSkipped(powerItem) {
        let powerPoints = powers[powerItem.id];
        if (powerPoints === undefined) {
            return false;
        }
        return powerPoints < 0;
    }

    function PowersAreFullyConnected(powerKeys) {
        
        if (powerKeys.size < 2) {
            return true;
        }
        let linkedIDs = new Set();
        let startID = Array.from(powerKeys)[0];
        linkedIDs.add(startID);
        powerKeys.delete(startID);

        while (powerKeys.size > 0) {
            let foundAnyLinks = false;
            let powerKeyArr = Array.from(powerKeys);
            for (const powerID in powerKeyArr) {
                const powerKey = powerKeyArr[powerID];
                for (let linkedID of linkedIDs) {
                    let link = GetLinkBetweenPowers(parseInt(linkedID), parseInt(powerKey));
                    if (link !== null
                        && (!link.isDotted
                            || link.id in dashedLinks)) {
                        // this is somewhere in our list
                        linkedIDs.add(powerKey);
                        foundAnyLinks = true;
                        powerKeys.delete(powerKey);
                        // we found a link, so we can break
                        break;
                    }
                }
            }
            if (!foundAnyLinks) {
                // none of the remanining power keys maps to any of the linked IDs! We cannot connect
                return false;
            }
        }
        return true;
    }

    function CanRemovePower(powerItem) {
        if (!IsPowerLearned(powerItem) && !IsPowerSkipped(powerItem)) {
            return false;
        }
        let copyPowers = structuredClone(powers);
        delete copyPowers[powerItem.id];
        let powerKeys = new Set(structuredClone(Object.keys(copyPowers)));
        for (let powerID in copyPowers) {
            if (copyPowers[powerID] === 0) {
                // skipped counts as connected, unlearned does not
                powerKeys.delete(powerID);
            }
        }
        return PowersAreFullyConnected(powerKeys);
    }

    function CanSkipPower(powerItem) {
        if (powerItem.isInvestigative || powerItem.isGRF) {
            return false;
        }
        if (IsPowerSkipped(powerItem)) {
            return false;
        }
        if (IsPowerLearned(powerItem)) {
            // we can switch to skipping something we've already learned
            return true;
        }
        return IsPowerAvailable(powerItem, true);
    }

    function ShowPointsForPower(powerItem) {
        if (powerItem.isInvestigative || powerItem.isGRF) {
            return false;
        }
        if (IsPowerSkipped(powerItem)) {
            return false;
        }
        if (IsPowerLearned(powerItem)) {
            // we can switch to skipping something we've already learned
            return true;
        }
        return false;
    }

    // note-- this refers to levels, not points spent.
    function CurrentPointsForPower(powerItem) {
        if (!ShowPointsForPower(powerItem)) {
            return 0;
        }
        return powers[powerItem.id];
    }

    function IsPowerAvailable(powerItem, isSkip=false) {
        if (!isEditable) {
            return false;
        }
        // we already have the power
        if (IsPowerLearned(powerItem)) {
            return false;
        }
        // we have skipped the power, so we can switch to actually learning it if we can afford it
        if (IsPowerSkipped(powerItem)) {
            return pointsRemaining >= 2;
        }
        const powerCost = CalculateLinkedPowerCost(powerItem, isSkip);
        if (powerCost < 0) {
            return false;
        }
        return pointsRemaining >= powerCost;
    }

    function GetLinksFromPower(powerItem) {
        let links = [];
        for (let linkID in linkData) {
            let link = linkData[linkID];
            if (link.powerIDs.includes(powerItem.id)) {
                links.push(link);
            }
        }
        return links;
    }

    let powerGridDict = {};

    const powerCards = powerData.map((item) => {

        let isAvailable = IsPowerAvailable(item);
        let isLearned = IsPowerLearned(item);
        let isSkipped = IsPowerSkipped(item);
        let canRemove = CanRemovePower(item);
        let canSkip = CanSkipPower(item);
        let isSelected = parseInt(item.id) === selectedPowerID;
        
        let showPoints = ShowPointsForPower(item);
        let canChangePoints = showPoints && isEditable;
        let canIncrement = pointsRemaining > 0;
        let currentPoints = CurrentPointsForPower(item);

        const powerLinks = GetLinksFromPower(item);

        const quadeGridX = item.position[0];
        const quadeGridY = item.position[1];

        const subX = item.subPosition[0];
        const subY = item.subPosition[1];
        // *4 because we need to draw multiple powers in the same grid cell
        const drawGridX = (4 * (quadeGridX)) + subX - 4;
        // 28 is 4 * 7. Add 1 to avoid squishing
        const drawGridY = 29 - ((4 * quadeGridY) + subY);
        powerGridDict[item.id] = [drawGridX, drawGridY];
        return (
            <PowerCard
                key={item.id}
                item={item}
                drawGridX={subX}
                drawGridY={5 - subY}
                quadeGridX={quadeGridX}
                quadeGridY={quadeGridY}
                isEditable={isEditable}
                isSelected={isSelected}
                isAvailable={isAvailable}
                isLearned={isLearned}
                isSkipped={isSkipped}
                canRemove={canRemove}
                canSkip={canSkip}
                showPoints={showPoints}
                canChangePoints={canChangePoints}
                canIncrement={canIncrement}
                currentPoints={currentPoints}
                powers={powers}
                setPowers={setPowers}
                solidLinks={solidLinks}
                setSolidLinks={setSolidLinks}
                dashedLinks={dashedLinks}
                setDashedLinks={setDashedLinks}
                powerLinks={powerLinks}
                setSelectedPowerID={setSelectedPowerID}
            />
        )
    });

    // links between cards
    const linkLines = linkData.map((d) => {
        if (d.path !== undefined) {
            return pathedLineComponent(d);
        }
        return linkLineComponent(d);
    });

    function pathedLineComponent(linkData) {

        // connected powers
        const powerIDs = linkData.powerIDs;
        const gridPos1 = powerGridDict[powerIDs[0]];
        const gridPos2 = powerGridDict[powerIDs[1]];

        const cellW = 134;
        const cellH = 134;

        const lineCoords = CalculateCardLineCoords(gridPos1, gridPos2, cellW, cellH);
        const lineCoords1 = lineCoords[0];
        const x0 = lineCoords1[0];
        const y0 = lineCoords1[1];
        const isDotted = linkData.isDotted;

        // line appearance
        const linkKeys = isDotted ? Object.keys(dashedLinks) : Object.keys(solidLinks);
        let isLinkLearned;
        if (isDotted) {
            isLinkLearned = linkKeys.includes(linkData.id.toString())
                && dashedLinks[linkData.id.toString()] > 0;
        } else {
            isLinkLearned = linkKeys.includes(linkData.id.toString())
                && solidLinks[linkData.id.toString()] > 0;
        }
        const lineComponents = linkData.path.map((coords) => {
            const index = linkData.path.indexOf(coords);
            // starting point
            let x1 = x0;
            let y1 = y0;

            if (index > 0) {
                let prevCoords = linkData.path[index - 1];
                x1 = x0 + prevCoords[0];
                y1 = y0 + prevCoords[1];
            } else {
                return null;
            }
            let x2 = x0 + coords[0];
            let y2 = y0 + coords[1];

            const lineStyle = LinkLineStyle(x1, y1, x2, y2, isDotted, isLinkLearned);
            return (
                <div style={lineStyle} key={index}>

                </div>
            );
        });
        return lineComponents;
    }

    function linkLineComponent(linkData) {
        const powerIDs = linkData.powerIDs;
        const gridPos1 = powerGridDict[powerIDs[0]];
        const gridPos2 = powerGridDict[powerIDs[1]];

        const cellW = 134;
        const cellH = 134;

        const lineCoords = CalculateCardLineCoords(gridPos1, gridPos2, cellW, cellH);
        const lineCoords1 = lineCoords[0];
        const lineCoords2 = lineCoords[1];        

        var x1 = lineCoords1[0];
        var y1 = lineCoords1[1];
        var x2 = lineCoords2[0];
        var y2 = lineCoords2[1];
        const isDotted = linkData.isDotted;
        const linkKeys = isDotted ? Object.keys(dashedLinks) : Object.keys(solidLinks);
        let isLinkLearned;
        if (isDotted) {
            isLinkLearned = linkKeys.includes(linkData.id.toString())
                && dashedLinks[linkData.id.toString()] > 0;
        } else {
            isLinkLearned = linkKeys.includes(linkData.id.toString())
                && solidLinks[linkData.id.toString()] > 0;
        }
        const lineStyle = LinkLineStyle(x1, y1, x2, y2, isDotted, isLinkLearned);
        return (
            <div style={lineStyle} key={linkData.id} >

            </div>
        );
    }

    function LinkLineStyle(x1, y1, x2, y2, isDotted, isLinkLearned) {
        const thickness = isLinkLearned ? 12 : 4; //temp
        var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        // center
        var cx = ((x1 + x2) / 2) + (thickness / 2) - (length / 2);
        var cy = ((y1 + y2) / 2) - (thickness / 2);
        var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);

        const borderStyle = (isDotted ? "dashed" : "solid") + " " + thickness + "px";
        let lineStyle = {
            padding: "0px",
            transform: "rotate(" + angle + "deg)",
            position: "absolute",
            left: "" + cx + "px",
            top: "" + cy + "px",
            width: "" + length + "px",
            height: "" + thickness + "px",
            lineHeight: "1px",
            border: "none",
            borderTop: borderStyle,
            color: "white",
            zIndex: "-1"
        };
        return lineStyle;
    }

    // supercells

    let superCells = [];
    let numSuperCols = 6;
    let numSuperRows = 7;
    for (let y = 1; y <= numSuperRows; y++) {
        for (let x = 1; x <= numSuperCols; x++) {
            superCells.push([x, y]);
        }
    }

    const superGridCells = superCells.map((c) => {
        let rowMod = c[1] % 2 === 1 ? 100 : 150;
        let colMod = c[0] % 2 === 1 ? 50 : 20;
        let colGradientMod = (7 - c[0]) * 10;
        let baseDark = -120;

        let dark = baseDark + rowMod + colMod + colGradientMod;
        let cellStyle = {
            gridArea: c[1] + "/" + c[0],
            backgroundColor: "rgb(" + dark + "," + dark + "," + dark + ")"
        };

        let filteredPowerCards = powerCards.filter(card =>
            card.props.quadeGridX === c[0] && card.props.quadeGridY === 7 - c[1]
        );

        return (
            <div className="App--quade-grid-supercell"
                key={"quadeCell-" + c[0] + "," + c[1]} style={cellStyle}>
                {filteredPowerCards}
            </div>);
    });

    // render
    return (
        <div style={{
            display: "flex",
            flexDirection: "column", width: "100%",
            position: "relative"
        }}>
            <div className="Symmetrical-topflare"
                style={{fontSize:"20px"} }>
                QUADE DIAGRAM
            </div>
            <div className="Tooltip-container-powers">
                <div className="Tooltip">
                    ?
                    <span className="Tooltip-text Tooltip-top">
                        Click the + button to add a power. This costs 4 points.
                        <br />Keep pressing the same button to spend more points.
                        <br />Skipping a power costs 2 points. GRFs cost 2 points
                        <br />in casual mode and no points in hardcore mode.
                        <br />Solid lines cost no points to traverse, and dashed lines cost 4 points.
                    </span>
                </div>
            </div>
            <div className="Powers--container-inner">
                <TransformWrapper
                    initialScale={minZoom}
                    initialPositionX={300}
                    initialPositionY={25}
                    minScale={minZoom}
                    maxScale={maxZoom}
                    limitToBounds={true}
                    wheel={{ smoothStep: 0.0005 }}
                >
                    <TransformComponent
                        wrapperStyle={{ width: "100%" }}
                    >
                        <div id="quade-contents"
                        className="Quade--overlay">               
                        {superGridCells}                        
                        {linkLines}
                            </div>
                    </TransformComponent>
                </TransformWrapper>
            </div>
        </div>
    )

    
};

export default Quade;